<template>
    <div class="ui-content dashboard">
        <div class="page-user">
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab"
                :centered="centered"
                :grow="grow"
                :vertical="vertical"
                :right="right"
                :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
                :icons-and-text="icons"
            >
                <v-tabs-slider></v-tabs-slider>
                <v-tab :key="i" :href="'#Coordinator'">Coordinator</v-tab>
                <v-tab :key="i" :href="'#Student'">Student</v-tab>
                <v-tab :key="i" :href="'#Parent'">Parent</v-tab>
                <v-tabs-items :touchless="true" v-model="tab">
                    <v-tab-item :key="i" :value="'Coordinator'">
                        <v-card class="mx-auto normal-card">
                            <UsersCoor />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item :key="i" :value="'Student'">
                        <v-card class="mx-auto normal-card">
                            <UsersStudent />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item :key="i" :value="'Parent'">
                        <v-card class="mx-auto normal-card">
                            <UsersParents />
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </div>
</template>
<script>
import UsersParents from "@/components/coordinator/users/ApprovedUsers/UsersParents.vue";
import UsersCoor from "@/components/coordinator/users/ApprovedUsers/UsersCoor.vue";
import UsersStudent from "@/components/coordinator/users/ApprovedUsers/UsersStudent.vue";
export default {
    name: "Users",
    components: {
        UsersParents,
        UsersCoor,
        UsersStudent
    },
    data() {
        return {
            tab: null,
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tabs: 3
        };
    }
};
</script>